import * as ngCdkDragDrop from '@angular/cdk/drag-drop'
import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'

import * as input from '../../../../../../input'
import * as overlay from '../../../../../../overlay'
import * as toggleButton from '../../../../../../toggle-button'
import { AtnDsTableStore } from '../../../../../store'

@ngCore.Component({
  imports: [
    input.checkbox.Component,
    ngCdkDragDrop.DragDropModule,
    overlay.attached.Component,
    toggleButton.Component,
  ],
  selector: 'settings-action-attached-overlay',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link HTMLElement}  */
  public readonly originSg = ngCore.input.required<HTMLElement>({
    alias: 'origin',
  })
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore)

  /** TODO:  */
  public settingsOverlayBackdropClickHandler() {
    this.store.patchState({ columnSettingsIsOpen: false })
  }

  /** TODO:  */
  public elementDropHandler(event: ngCdkDragDrop.CdkDragDrop<any>): void {
    const plugin = this.store.pluginSg()
    plugin?.collection.plugins.attributePlugin.feature.actions.reorderAttributes
      .from('Table.WidgetActions.SettingsOverlay.DragAndDrop.Dropped')
      .dispatch({
        fromIndex: event.previousIndex,
        toIndex: event.currentIndex,
      })
  }
  /** TODO:  */
  public cellContentTogglerHandler(shouldWrap: boolean) {
    this.store.patchState({ isCellContentWrapped: shouldWrap })
  }
  /** TODO:  */
  public attributeVisibilityChangeHandler(
    isHidden: boolean,
    attribute: ents.core.common.Attribute,
  ) {
    const plugin = this.store.pluginSg()
    plugin?.collection.plugins.attributePlugin.feature.actions[
      isHidden ? 'showAttribute' : 'hideAttribute'
    ]
      .from(`Table.WidgetActions.SettingsOverlay.Rows.${attribute.id}.Clicked`)
      .dispatch({ attributeId: attribute.id })
  }
}
